import { FC } from 'react';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import { ResultSearchType } from '@savgroup-front-common/core/molecules/SearchWithDimmer/SearchWithDimmer.types';
import { RESULT_TYPE } from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

import { ClearableSearchInputGroup } from '../../../ClearableSearchInputGroup/ClearableSearchInputGroup';

import { AppBarSearchResultsList } from './AppBarSearchResultsList';
import messages from './messages';

interface AppBarSearchPanelProps {
  query?: string;
  isLoading: boolean;
  isFetchingMore: boolean;
  focusedResultType?: RESULT_TYPE;
  results: SearchResultList<ResultSearchType>[];
  onSearch: (value: string) => void;
  onShowMore: (resultType: RESULT_TYPE) => void;
  onSelectResult: () => void;
  inputDataTestId: string;
  clearDataTestId: string;
}

export const AppBarSearchPanel: FC<AppBarSearchPanelProps> = ({
  query = '',
  isLoading,
  isFetchingMore,
  focusedResultType,
  results,
  onSearch,
  onShowMore,
  onSelectResult,
  inputDataTestId,
  clearDataTestId,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <ClearableSearchInputGroup
        value={query}
        onChange={onSearch}
        placeholder={safeFormattedIntlString(messages.searchPlaceholder)}
        clearAriaLabel={safeFormattedIntlString(messages.clearSearch)}
        isLoading={isLoading}
        autoFocus
        inputDataTestId={inputDataTestId}
        clearDataTestId={clearDataTestId}
      />

      <AppBarSearchResultsList
        query={query}
        isLoading={isLoading}
        isFetchingMore={isFetchingMore}
        focusedResultType={focusedResultType}
        results={results}
        onShowMore={onShowMore}
        onSelectResult={onSelectResult}
      />
    </div>
  );
};
